class AccessibilityRevamp extends HTMLElement {
  connectedCallback() {
    if (this.dataset.accessibilityRevampBound === 'true') return;
    this.dataset.accessibilityRevampBound = 'true';
    this.enhanceEmailLink();
  }

  enhanceEmailLink() {
    const emailLink = this.querySelector('.accessibility-revamp__link');
    if (!emailLink || emailLink.dataset.enhanced === 'true') return;

    const email = this.dataset.email;
    if (email && !emailLink.getAttribute('href')) {
      emailLink.setAttribute('href', `mailto:${email}?subject=Disabled%20Access`);
    }

    emailLink.dataset.enhanced = 'true';
  }
}

if (!customElements.get('accessibility-revamp')) {
  customElements.define('accessibility-revamp', AccessibilityRevamp);
}

document.addEventListener('shopify:section:load', (event) => {
  const section = event.target.querySelector('accessibility-revamp');
  if (!section) return;
  section.dataset.accessibilityRevampBound = 'false';
  section.connectedCallback();
});
